import { configureStore } from "@reduxjs/toolkit";
import themeReducer from "./theme/themeSlice";
import authReducer from "./auth/authSlice";
import loadingReducer from "./loader/loadingSlice";
import securityRuleReducer from "./security-rule/securityRuleSlice";
import securityGroupReducer from "./security-group/securityGroupSlice";
import companyReducer from "./company/companySlice";
import dashboardReducer from "./dashboard/dashboardSlice";
import categoryReducer from "./product/categorySlice";
import subcategoryReducer from "./product/subcategorySlice";
import productReducer from "./product/productSlice";
import blogReducer from "./blog/blogSlice";

import menuReducer from "./menu/menuSlice";

import logger from "redux-logger";

const middlewares = [];

// Add redux-logger only in development mode
if (process.env.NODE_ENV === "development") {
  middlewares.push(logger);
}

const store = configureStore({
  reducer: {
    theme: themeReducer,
    auth: authReducer,
    loading: loadingReducer,
    securityRule: securityRuleReducer,
    securityGroup: securityGroupReducer,
    company: companyReducer,
    menu: menuReducer,
    dashboard: dashboardReducer,
    category: categoryReducer,
    subcategory: subcategoryReducer,
    product: productReducer,
    blog: blogReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(middlewares),
});

export default store;
